// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"42":"ae563fd5","182":"41d2f5e9","453":"2736ed05","661":"2a0e43c0","917":"9c505520","952":"c3bb1206"}[chunkId] + ".chunk.js";
};